import { render, staticRenderFns } from "./SingleProfileCard.vue?vue&type=template&id=0defcaa7&scoped=true&"
import script from "./SingleProfileCard.vue?vue&type=script&lang=js&"
export * from "./SingleProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./SingleProfileCard.vue?vue&type=style&index=0&id=0defcaa7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0defcaa7",
  null
  
)

export default component.exports